<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading"/>
    <div v-else>
      <div class="no_left_content">
        <h5 class="common_subtitle pb_20 border-lightgray-bottom mb_20">Add network </h5>
        <div class="vm_checkout_content">
          <div class="vm_checkout_left">
            <div class="mb-3">
              <label for="kt_platform" class="col-form-label">Platform</label>
              <select class="form-select" id="kt_platform" v-model="form.kt_platform" @change="changePlatform()">
                <option v-for="(serverPlatform, index) in serverPlatforms" :key="'kt_platform_'+index"
                        :value="serverPlatform.label">
                  {{ serverPlatform.value }}
                </option>
              </select>
              <v-errors :errors="errorFor('kt_platform')"></v-errors>
            </div>
            <div class="mb-3">
              <label for="server_region_id" class="col-form-label">Region</label>
              <select class="form-select" id="server_region_id" v-model="form.server_region_id">
                <option v-for="(serverRegion, index) in serverRegions" :key="'server_region_'+index"
                        :value="serverRegion.id">
                  {{ serverRegion.name }}
                </option>
              </select>
              <v-errors :errors="errorFor('server_region_id')"></v-errors>
            </div>
            <div class="mb-3">
              <label for="billing_type" class="col-form-label">Billing type</label>
              <select class="form-select" v-model="form.billing_type" id="billing_type">
                <option value="monthly">Monthly</option>
                <option value="hourly">Hourly</option>
              </select>
              <v-errors :errors="errorFor('billing_type')"></v-errors>
            </div>
          </div>
          <div class="vm_checkout_right">
            <div class="vm_checkout_right_wrap">
              <h5 class="common_subtitle">Estimated Bill </h5>
              <div class="checkout_right_inner">
                <div class="d_flex_btwn inner_title">
                  <span>Network details</span>
                  Kt cloud price: {{ formatPrice(getKtCloudPrice) }}
                  <br>
                  Vlan24 price: {{ formatPrice(getVlan24Price) }}
                </div>
                <div class="checkout_subtotal">
                  <p class="mb_5">Total estimated bill({{ form.billing_type }})</p>
                  <h2 class="subtotal">{{ formatPrice(getVlan24Price) }}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d_flex_end custom_border_top mt_20 pt_20 pb_20">
        <button type="button" class="btn btn-outline-danger mr_5" @click.prevent="cancelOperation()">Cancel</button>
        <button type="button" class="btn btn-primary btn-md  width_100p" v-if="form.kt_platform == 'g'"
                :disabled="lyLoading" @click.prevent="submit">Launch
        </button>
        <button type="button" class="btn btn-primary btn-md  width_100p" v-else :disabled="lyLoading"
                @click.prevent="submitForDPlatform">Launch
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";

export default {
  name: 'cloud-network-form',
  components: {LoaderMaskComponent},
  data() {
    return {
      lyLoading: false,
      form: {
        kt_platform: 'g',
        server_region_id: '',
        billing_type: 'hourly',
      },
      serverRegions: [],
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo'
    }),
    getVlan24Price(){
      let price = 0
      if(this.form.billing_type == 'monthly'){
        price =  5000 - (5000 * (this.customer.commission/100))
      }else if(this.form.billing_type == 'hourly'){
        price =  7 - (7 * (this.customer.commission/100))
      }
      return Math.ceil(price)
    },
    getKtCloudPrice(){
      let price = 0
      if(this.form.billing_type == 'monthly'){
        price =  5000
      }else if(this.form.billing_type == 'hourly'){
        price =  7
      }
      return Math.ceil(price)
    },
    serverPlatforms() {
      if (this.customer.g_platform && this.customer.d_platform) {
        return [
          {label: 'g', value: 'G'},
          {label: 'd', value: 'D'},
        ];
      } else if (this.customer.g_platform) {
        return [
          {label: 'g', value: 'G'},
        ];
      } else if (this.customer.d_platform) {
        return [
          {label: 'd', value: 'D'},
        ];
      } else {
        return [
          {label: 'g', value: 'G'},
        ];
      }
    }
  },
  created() {
    this.loadServerRegions()
  },
  methods: {
    changePlatform() {
      this.loadServerRegions()
    },
    loadServerRegions() {
      this.axios.get('/server-regions/' + this.form.kt_platform)
          .then(({data}) => {
            this.serverRegions = data.data
            if (this.serverRegions.length > 0) {
              this.form.server_region_id = this.serverRegions[0].id
            } else {
              this.form.server_region_id = ''
            }
          })
    },
    cancelOperation() {
      this.$swal({
        title: 'Are you sure want to cancel?',
        text: "It will stop network creation!",
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push('cloud-networks');
        }
      });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      this.axios.post('/cloud-networks', this.form)
          .then((response) => {
            if (response.data.success) {
              this.showSuccessMsg(response.data.message);
              this.$router.push('cloud-networks');
            } else {
              this.$swal({
                text: response.data.message,
                showCancelButton: false,
                confirmButtonText: 'Close!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
              })
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    submitForDPlatform() {
      this.allErrors = null;
      this.lyLoading = true;

      this.axios.post('/create-kt-d-cloud-network', this.form)
          .then((response) => {
            if (response.data.success) {
              this.showSuccessMsg(response.data.message);
              this.$router.push('cloud-networks');
            } else {
              this.$swal({
                text: response.data.message,
                showCancelButton: false,
                confirmButtonText: 'Close!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
              })
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
  }
}
</script>
<style scoped>

</style>